import { render, staticRenderFns } from "./PageUpsell.vue?vue&type=template&id=13cb77b4"
import script from "./PageUpsell.vue?vue&type=script&lang=js"
export * from "./PageUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports